import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Paper, FontIcon, RaisedButton, TextField } from 'material-ui';
import { FormattedMessage } from 'react-intl';
import { normalizeNumber } from 'utils/normalize';

import styles from 'styles/KBenefit';
import KTitle from './KTitle';
import convert from '../../utils/dateTools';

let fileInput;

const KBenefit = ({
  FileRepositoryObjectDocumentTypeID,
  Email,
  HrBenefitName,
  HrBenefitText,
  XapEmailTemplateBody,
  employeeName,
  onEmail,
  onUpload,
  HrBenefitID,
  onRequestGrant,
  HrBenefitType,
  Link,
  PayRecordSum,
  EndDate,
  Amount,
  loading,
}) => {
  const [files, setFiles] = useState([]);
  const [amount, setAmount] = useState(0);

  const handleAmountInput = (e) => {
    const { value } = e.target;
    if (value) {
      setAmount(normalizeNumber(value));
    }
  };

  const handleFile = (e) => {
    const fileArray = Array.from(e.target.files);
    setFiles(fileArray || []);
  };

  const submitFile = (e) => {
    e.preventDefault();
    if (!FileRepositoryObjectDocumentTypeID || !files.length) return;
    onUpload(
      files,
      FileRepositoryObjectDocumentTypeID,
      () => { if (fileInput) fileInput.value = ''; },
      Email,
      () => onEmail({
        To: Email.split(','),
        Subject: `${HrBenefitName} - ${employeeName}`,
        Attachments: files,
        Body: HrBenefitText || XapEmailTemplateBody,
      })
    );
  };

  const requestGrant = async () => {
    if (!HrBenefitID || !amount || !FileRepositoryObjectDocumentTypeID || !files.length) return;
    try {
      onRequestGrant(
        HrBenefitID,
        Number(amount),
        files,
        FileRepositoryObjectDocumentTypeID,
        () => { if (fileInput) fileInput.value = ''; },
        Email,
        () => onEmail({
          To: Email.split(','),
          Subject: `${HrBenefitName} - ${employeeName}`,
          Attachments: files,
          Body: HrBenefitText || XapEmailTemplateBody,
        })
      );
    } catch (error) {
      throw error;
    }
  };

  const body = XapEmailTemplateBody || HrBenefitText || '';

  const chooseButton = () => {
    if (HrBenefitType === 2) {
      return (
        <RaisedButton
          style={styles.actionButton}
          disabled={amount > (Amount - Number(PayRecordSum)) || !files.length || loading}
          label={loading
            ? <FormattedMessage id="benefit.loading" />
            : <FormattedMessage id="benefit.request" />
          }
          onClick={requestGrant}
          data-cy="submit-grant"
        />
      );
    }
    if (Link) {
      return (
        <RaisedButton
          style={styles.actionButton}
          icon={<FontIcon className="material-icons">link</FontIcon>}
          labelPosition="before"
          label={<FormattedMessage id="benefit.apply" />}
          target="_blank"
          href={Link}
        />
      );
    }
    if (FileRepositoryObjectDocumentTypeID !== 0 && Email) {
      return (
        <RaisedButton
          style={styles.actionButton}
          disabled={!files.length}
          label={<FormattedMessage id="benefit.sendFile" />}
          onClick={submitFile}
        />
      );
    }
    return null;
  };

  let remainingAmount = 0;
  if (Amount) {
    remainingAmount = Amount - Number(PayRecordSum || 0);
  }

  return (
    <Paper style={styles.container} zDepth={0} data-cy="single-grant">
      <KTitle style={styles.title} title={HrBenefitName} />
      <div style={styles.description} dangerouslySetInnerHTML={{ __html: body }} />
      <div style={styles.times} />
      {EndDate
        ? <div style={styles.amount}><FormattedMessage id="benefit.validUntil" values={{ val: convert(EndDate) }} /></div>
        : <div />
      }
      {Amount
        ? <div style={styles.amount}><FormattedMessage id="benefit.amount" values={{ val: (Amount).toLocaleString('de', { maximumFractionDigits: 2 }) }} /></div>
        : <div />
      }
      {Amount
        ? <div style={styles.amount}><FormattedMessage id="benefit.payRecordSumRemaining" values={{ val: (remainingAmount).toLocaleString('de', { maximumFractionDigits: 2 }) }} /></div>
        : <div />
      }

      {(HrBenefitType === 2)
        ? (
          <div>
            <TextField
              style={styles.amountInput}
              floatingLabelFixed
              floatingLabelText={<FormattedMessage id="benefit.receipt" />}
              hintText={<FormattedMessage id="benefit.receipt.hint" />}
              type="number"
              onChange={handleAmountInput}
              data-cy="grant-amount"
            />
          </div>
        )
        : <div />
      }
      {(FileRepositoryObjectDocumentTypeID !== 0 && onUpload) &&
        <input
          style={styles.fileInput}
          type="file"
          ref={(x) => { fileInput = x; }}
          multiple
          onChange={handleFile}
        />
      }
      <div style={styles.action}>
        {chooseButton()}
      </div>
    </Paper>
  );
};

KBenefit.propTypes = {
  HrBenefitID: PropTypes.number,
  HrBenefitName: PropTypes.string,
  HrBenefitText: PropTypes.string,
  HrBenefitType: PropTypes.number,
  Link: PropTypes.string,
  FileRepositoryObjectDocumentTypeID: PropTypes.number,
  Email: PropTypes.string,
  PayRecordSum: PropTypes.string,
  onUpload: PropTypes.func,
  onRequestGrant: PropTypes.func,
  onEmail: PropTypes.func,
  XapEmailTemplateBody: PropTypes.string,
  EndDate: PropTypes.string,
  employeeName: PropTypes.string,
  Amount: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
};

KBenefit.defaultProps = {
  onUpload: null,
  onEmail: null,
  employeeName: '',
};

export default KBenefit;



// WEBPACK FOOTER //
// ./src/components/KJRN/KBenefit.js